<template>
  <!-- header -->
  <header class="header header--sub gbin-gradient py-4">
    <div class="container px-4 px-sm-3">
      <div class="row">
        <div class="col-12 col-lg-2 text-center text-lg-start">
          <h1 class="h4 mb-3 mb-lg-0">
            <router-link
              class="d-flex align-items-center justify-content-center justify-content-lg-start text-white"
              to="/"
            >
              <img
                class="header__logo img-fluid me-2"
                src="@/assets/data-port-gbin-white.svg"
                alt="Dataports"
              />
              GBIN
            </router-link>
          </h1>
        </div>

        <div
          class="d-md-flex align-items-center justify-content-center col-12 col-lg-6 text-center"
        >
          <div class="h5 fw-normal text-white mb-2 mb-md-0">
            {{ totalCount }} brands already listed
          </div>
          <router-link
            class="btn btn-primary btn-sm rounded-pill fw-bold ms-md-3"
            to="/get-your-gbin"
          >
            Get your GBIN
          </router-link>
        </div>

        <div class="col-12 col-lg-4 pt-3">
          <Search :total-count="totalCount" :isCompact="true"></Search>
        </div>
      </div>
    </div>
  </header>
  <!-- /header -->
</template>

<script setup>
import { onMounted, ref } from "vue";
import { api } from "@/utils/api";

import Search from "@/components/Search.vue";

/**
 *  GETTING & LOADING (API) DATA
 */

// API results variables
const totalCount = ref(0);

// MOUNTED
onMounted(() => {
  getTotalCount();
});

// Load API Count data
async function getTotalCount() {
  try {
    const response = await api.getTotalCount();
    totalCount.value = response.data.totalCount;
  } catch (error) {
    console.error(error);
  }
}
</script>

<style lang="scss" scoped>
/*  ==========================================================================
    Header
    ========================================================================== */
/*  Header > Logo
    ========================================================================== */
.header__logo {
  max-width: 60px;
}
</style>
